import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';

import React from 'react';
import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';
import style from './style.module.less';
import messages from './messages';

/**
 * @param {object} props
 * @param {boolean} props.disabled
 * @param {() => void} props.onClick
 * @returns {JSX.Element}
 */
export const AddShopperButton = ({ disabled = false, onClick }) => {
  return (
    <div className={style['add-shopper-button']}>
      <Button className={style['add-shopper']} disabled={disabled} onClick={onClick} theme='primary'>
        <FontAwesomeIcon className={style['add-shopper-icon']} icon={faPlus} />
        <Text textType={TextType.Paragraph} value={messages.addShopperButtonText} />
      </Button>
    </div>
  );
};
